module.exports = __webpack_public_path__ + "img/dynamic-16.1e50c92b.png";